import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
    namespaced: true,
    state: {
        lstOfh: [],
        ofh: null,
        product: {},
        pr0: {},
        insert: false,
        update: false,
        loading: false,
        itemsPerPage: 20,
        search: "",
        hasNext: false,
        lastUpdatedRegister: null,
        pending: false,
        ofg: null,
    },
    getters: {
        getUpdate(state) {
            return state.update
        },
        getOfh(state) {
            let ofh = { ...state.ofh }
            return ofh
        },
        getOfhdoc(state) {
            return state.ofh.ofhdoc
        },
        getSearch(state) {
            return state.search
        },
        getItemsPerPage(state) {
            return state.itemsPerPage
        },
        getProduct(state) {
            return state.product
        }
    },
    mutations: {
        set(state, ofh) {
            if (ofh)
                state.update = true
        },
        initForm(state) {
            state.insert = false
            state.update = false
            state.ofh = {}
        },
        setParamsDataTable(state, payload) {
            state.lstOfh = payload.items
            state.itemsPerPage = payload.limit
            state.hasNext = payload.hasNext
        },
        setLoading(state, loading) {
            state.loading = loading
        },
        setOfh(state, ofh) {
            state.ofh = ofh
        },
        setOfg(state, ofg) {
            state.ofg = ofg
        },
        setLstOfh(state, lstOfh) {
            state.lstOfh = lstOfh
        },
        setHasNext(state, hasNext) {
            state.hasNext = hasNext
        },
        setSearch(state, search) {
            state.search = search
        },
        setLastUpdatedRegister(state, lastUpdatedRegister) {
            state.lastUpdatedRegister = lastUpdatedRegister
        },
        setProduct(state, product) {
            state.product = product
        },
    },
    actions: {
        initForm({ commit }) {
            commit("initForm")
        },
        async find({ commit, dispatch }, ofhdoc) {
            commit("setLoading", true)
            commit("initForm")
            await this._vm.$axios.get(`/Products/NonConformingPieces/FindByDoc/${ofhdoc}`)
                .then(response => {
                    let ofh = Utils.ValidateAxiosResponse(response.data);
                    commit("setOfh", ofh)
                    commit("set", ofh)
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                });
            commit("setLoading", false)
        },
        async save({ getters, dispatch }) {
            if (getters.getUpdate) {
                return await dispatch("update")
            }
            return await dispatch("insert")
        },
        async insert({ commit, getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.post("/Products/NonConformingPieces/Insert", getters.getOfh)
                .then(response => {
                    commit('setLastUpdatedRegister', Utils.ValidateAxiosResponse(response.data));
                    commit("setOfh", {})
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload;
        },
        async update({ commit, getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.put("/Products/NonConformingPieces/Update", getters.getOfh)
                .then(response => {
                    commit('setLastUpdatedRegister', Utils.ValidateAxiosResponse(response.data));
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload
        },
        async delete({ getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, { root: true })
            await this._vm.$axios.delete(`/Products/NonConformingPieces/Delete/${getters.getOfhdoc}`)
                .then(response => {
                    Utils.ValidateAxiosResponse(response.data);
                    router.push("/oryxpdv/pecas-nao-conformes")
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
        },
        async findList({ commit, getters, dispatch }) {
            commit("setLoading", true)
            commit("initForm")
            await this._vm.$axios.get(`/Products/NonConformingPieces/FindList`, getters.getOfh)
                .then(response => {
                    let lstOfh = Utils.ValidateAxiosResponse(response.data);
                    commit("setLstOfh", lstOfh)
                    commit("setHasNext", lstOfh.length > getters.getItemsPerPage)
                }).catch(error => {
                    commit("setLstOfh", [])
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                })
            commit("setLoading", false)
        },
        async search({ commit, getters, dispatch }, { limit = 20, page = 1 }) {
            commit("setLoading", true)
            commit("initForm")
            let payload = await this._vm.$axios.get(`/Products/NonConformingPieces/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`)
                .then(response => {
                    let payload = Utils.ValidateAxiosResponse(response.data);
                    commit("setParamsDataTable", payload)
                    return true
                })
                .catch((error) => {
                    commit("setLstOfh", [])
                    commit("setSearch", "")
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            commit("setLoading", false)
            return payload
        },
        async findProductByPiece({ commit, dispatch }, ofhpeca) {
            await this._vm.$axios.get(`/Products/NonConformingPieces/FindProductByPiece/${ofhpeca}`)
                .then(response => {
                    let product= Utils.ValidateAxiosResponse(response.data);
                    commit("setProduct", product)
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                });
        },
        async findReasonByProduct({ commit, dispatch }, ofhpeca) {
            await this._vm.$axios.get(`/Products/NonConformingPieces/FindReasonByProduct/${ofhpeca}`)
                .then(response => {
                    let ofh = Utils.ValidateAxiosResponse(response.data);
                    commit("setOfh", ofh)
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                });
        },
    }
}